import { LOCALSTATUS as localStatusList } from '../../config';
import updateFormStatus from './updateFormStatus';
import getFormsLocal from './getFormsLocal';

export default async function () {
  const forms = await getFormsLocal();
  if (forms.length === 0) return true;
  const updateSendingFormsPromises = forms.map(async (form) => {
    if (form.localStatus === localStatusList.sending) {
      await updateFormStatus(form.id, localStatusList.to_send, 'localStatus');
    }
  });
  Promise.all(updateSendingFormsPromises);
  // cleanDbForms();

  return true;
}
